module.exports = __webpack_public_path__ + "img/bjtuiguang.ff67a298.png";